import { Star } from '@icons';

/**
 * Blurb rating component.
 */
export default function BlurbRating({ rating, maxScore = 5, className = '' }) {
  let scoreValue;
  let finalMaxScore = maxScore;

  if (typeof rating === 'object' && rating !== null) {
    scoreValue = rating.score || rating.value;
    finalMaxScore = rating.maxScore || maxScore;
  } else {
    scoreValue = rating;
  }

  if (!scoreValue) return null;

  const numScore = parseFloat(scoreValue);
  if (isNaN(numScore)) return null;

  const stars = [];
  for (let i = 0; i < finalMaxScore; i++) {
    stars.push(<Star key={i} />);
  }

  return numScore > 0.0 ? (
    <div className={`Blurb__rating ${className}`}>
      <span className="Blurb__rating-score">{numScore.toFixed(1)}</span>
      <div className="Blurb__rating-stars">{stars}</div>
    </div>
  ) : null;
}
